import { MFA_REQUIRED, MFA_SETUP_REQUIRED } from 'actions/session';

export const getMfaStatus = state => state.getIn(['mfa', 'status']);

export const getMfaSession = state => state.getIn(['mfa', 'session']);

export const getMfaEmail = state => state.getIn(['mfa', 'email']);

export const getSecretCode = state => state.getIn(['mfa', 'secretCode']);

export const getOtpAuthUri = state => state.getIn(['mfa', 'otpAuthUri']);

export const getIsCodeRequired = state => getMfaStatus(state) === MFA_REQUIRED;

export const getIsSetupRequired = state => getMfaStatus(state) === MFA_SETUP_REQUIRED;
